import './index.styl';
import _ from 'lodash';
import template from './index.jst';
import { View } from 'backbone.marionette';
import { Model } from 'backbone';
import Radio from "backbone.radio";
import ErrorsModal from '../../utils/ErrorsModal';
import { getSponsorLogo } from '../../utils';

const celebrityPopupChannel = Radio.channel( 'celebrity_popup' );

export class CelebrityPopup extends View {
	get template() {
		return template;
	}

	get className(){
		return 'celebrity-popup';
	}

	ui(){
		return {
			close:       '.js-close',
			add_teams:   '.js-add-selection-teams',
			team_select: '.js-team-select'
		}
	}

	events(){
		return {
			'click @ui.close':        'closePopup',
			'click @ui.add_teams':    'addTeams',
			'change @ui.team_select': 'teamSelect'
		}
	}

	initialize() {
		this.model      = new Model({
			teams: {},
			sponsor_logo: getSponsorLogo()
		});
		this.league_id  = this.getOption( 'league_id' );
		this.initListeners();
	}

	updateModel() {
		this.model.set({
			teams: this.collection.toJSON()
		});

		return this;
	}

	fetchData() {
		return this.collection.show_my({
			league_id: this.league_id
		});
	}

	initListeners() {
		this.listenTo( celebrityPopupChannel, 'open:celebrity:popup', this.showPopup );
		this.listenTo( celebrityPopupChannel, 'update:popup', this.updatePopUp );
		this.listenTo( this.collection, 'add:celebrity:teams:success', this.addCelebritySuccess );
		this.listenTo( this.collection, 'add:celebrity:teams:error', this.addCelebrityError );
		return this;
	}

	teamSelect() {
		let $add_teams_button = this.getUI( 'add_teams' );

		if( $('.celebrity-popup-body input:checked').length > 0 ) {
			$add_teams_button.removeClass( 'disable' );
		}
		else {
			$add_teams_button.addClass( 'disable' );
		}

	}

	addTeams( element ) {
		let is_send_teams = !$(element.currentTarget).hasClass('disable');

		if ( is_send_teams ) {
			let $checked_teams = $('.celebrity-popup-body input:checked'),
				teams = [];

			_.each( $checked_teams, team => {
				teams.push( $(team).val() );
			} );

			let data = {
				league_id: this.league_id,
				teams:     teams
			};

			this.collection.add_celebrity_teams( data );
		}
	}

	addCelebritySuccess() {
		celebrityPopupChannel.trigger( 'added:celebrity:teams' );
		this.closePopup();
	}

	addCelebrityError( errors ) {
		ErrorsModal.show( errors );
	}

	async updatePopUp() {
		await this.fetchData();
		this.updateModel()
			.render();
	}

	closePopup(){
		$('.celebrity-popup').hide();
		return this;
	}

	showPopup(){
		$('.celebrity-popup').show();
		return this;
	}
}

export default CelebrityPopup;